var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticStyle:{"float":"left"},attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.reQuery2(_vm.current.contentName)}}},[_vm._v(_vm._s(_vm.$t('查询')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }